import { eventBus } from '@tools/event-bus';

export const showLoginModal = (selector, redirectUrl) => {
  document
    .querySelectorAll(selector)
    .forEach((element) => {
      element.addEventListener('click', () => {
        eventBus.dispatchEvent(new CustomEvent('show-login-modal', {
          detail: {
            email: null,
            redirectUrl,
          },
        }));
      });
    });
};
